<template>
  <div id="app">
		  <transition :name="transitionName">
			  <keep-alive>
					<router-view/>
			 </keep-alive>
		</transition>
  </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex'
export default{
  data(){
    return{
      "transitionName":"",
    }
  },
  created(){
	if(this.is_xhn()||this.is_mini()||this.is_OpenHarmony()||this.is_xbrmcb()){
		this.set_xhn(true)
	}
	if(process.env.NODE_ENV !== 'production'){
		this.set_xhn(true)
	}
  },
  methods:{
	...mapMutations(['set_xhn']),
	is_xhn(){
		//新湖南云判断
		var UA = window.navigator.userAgent;
		var isAndroid = UA.indexOf('Android') > 0;
		var isIOS = /iPhone|iPad|iPod|iOS/.test(UA);
		var isXinhunan = false;
		if (isAndroid || isIOS) {
		//确定是在安卓,苹果手机中再判断是否在新湖南(ios 12 UA会写入失败，这里忽略)
		if(UA.substring(0,7)==="xhnyzs-"||UA.substring(0, 4) === "xhn-" || UA.startsWith("Mozilla/5.0 (iPhone; CPU iPhone OS 12"))
		{
			isXinhunan = true;
		}	
		}
		return isXinhunan;
	},
	is_xbrmcb(){
		var UA = window.navigator.userAgent;
		return UA.startsWith("xbrmcb-")
	},
	is_mini(){//是否小程序判断
		return window.__wxjs_environment === 'miniprogram';
	},
	is_OpenHarmony(){//是否是鸿蒙
		var UA = window.navigator.userAgent;
		return /OpenHarmony/g.test(UA)
	}
  },
  watch:{
	  '$route'(to, from){
		  if(from.name != null){
			if(from.meta.index > to.meta.index){
				this.transitionName = 'turn-off'
			}else{
				this.transitionName = 'turn-on'
			}
		  }
		
	  }
  },
}
</script> 
<style scoped>
/* 页面跳转动画 */
	.turn-on-enter {
	transform: translate3d(100%, 0, 0);
	}
	.turn-on-leave-to {
	transform: translate3d(-100%, 0, 0); 
	}
	.turn-on-enter-active,
	.turn-on-leave-active {
	transition: transform 0.4s ease;
	}
	.turn-off-enter {
	transform: translate3d(-100%, 0, 0); 
	}
	.turn-off-leave-to {
	transform: translate3d(100%, 0, 0);
	}
	.turn-off-enter-active,
	.turn-off-leave-active {
	transition: transform 0.4s ease;
	}
	.turn-off-leave-active {
	z-index: 2;
	}
</style>
